// extracted by mini-css-extract-plugin
export default {"PerformanceReview":"styles_PerformanceReview__mPq6W","reviewContainer":"styles_reviewContainer__MyopH","textArea":"styles_textArea__uVvgQ"};